import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import AlertBanner from 'tio-reimagined/components/alert-banner';
import Button from 'tio-reimagined/components/button';
import Text from 'tio-reimagined/components/text';
import { presentationForSlrLoanStanding } from 'tio-employee/utils/slr-loan-standing-verification';
import type { SlrLoanStandingAuditState } from 'tio-employee/types/slr-loan-standing-verification';

interface LoanStandingAlertCardSignature {
  Args: {
    state: SlrLoanStandingAuditState;
    onOpenUpload: () => void;
  };
  Element: HTMLDivElement;
}

const UPLOAD_ACTIONS = new Set(['upload_document', 'upload_newer_document', 'confirm_name_match']);

export default class LoanStandingAlertCard extends Component<LoanStandingAlertCardSignature> {
  get presentation() {
    return presentationForSlrLoanStanding(this.args.state);
  }

  get showUploadAction() {
    return UPLOAD_ACTIONS.has(this.args.state.action);
  }

  get showContactSupportAction() {
    return this.args.state.action === 'contact_support';
  }

  get ctaKey() {
    return this.presentation.ctaKey ?? 'slr.loan_standing.actions.upload_document';
  }

  <template>
    <AlertBanner
      @intent={{this.presentation.intent}}
      @title={{t this.presentation.titleKey}}
      data-test-slr-loan-standing-alert-card
      ...attributes
    >
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <Text @size="sm">{{t this.presentation.descriptionKey}}</Text>

        {{#if this.showUploadAction}}
          <Button
            @intent="primary"
            @size="sm"
            data-test-slr-loan-standing-alert-upload-button
            {{on "click" @onOpenUpload}}
          >
            {{t this.ctaKey}}
          </Button>
        {{else if this.showContactSupportAction}}
          <LinkTo
            @route="authenticated.contact-us"
            class="text-sm font-medium text-teal-700 underline whitespace-nowrap"
            data-test-slr-loan-standing-alert-contact-support-link
          >
            {{t this.ctaKey}}
          </LinkTo>
        {{/if}}
      </div>
    </AlertBanner>
  </template>
}
